import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Functions } from '../../helpers/functions';
import { StampRallyCustomerPrizePaperVoucherResponse, StampRallyCustomerPrizeRequest } from '../../models/stamp-rally-customer-prize-paper-voucher/stamp-rally-customer-prize-paper-voucher';

const stampRallyPaperVoucherPrizePostUrl = environment.centerServer.domain + '/gotch-event/v1/stamp-rally-paper-voucher-customer-prize';

@Injectable({
    providedIn: 'root',
})
export class StampRallyCustomerPrizePaperVoucherService {
    constructor(private readonly http: HttpClient) { }

    postPaperVoucherPrize(
        request: StampRallyCustomerPrizeRequest
    ): Observable<StampRallyCustomerPrizePaperVoucherResponse> {
        return this.http.post<StampRallyCustomerPrizePaperVoucherResponse>(
            stampRallyPaperVoucherPrizePostUrl,
            request,
            Functions.getDefaultHeaderWithBearerToken()
        );
    }
}
